import { useCallback, useEffect, useRef } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Text used with textShadow which Typography doesn't support
import { ImageBackground, Text } from 'react-native';
import { Flex, Typography, ColorValues } from '@banhala/ui-kit';
import type { NeonSignBoardProps, NeonBannerItem } from './types';
import type { AnyObject } from '../../../../types';
import { bridge, isNil } from '../../../../utils';
import { useOpenDeeplink } from '../../../../hooks';

interface NeonSignBoardItemProps {
  item: NeonBannerItem;
  logging: AnyObject;
}

const NeonSignBoardItem = ({ item, logging }: NeonSignBoardItemProps) => {
  const { title, id, background_image, deeplink } = item;
  const { openDeeplink } = useOpenDeeplink();

  const handlePress = useCallback(() => {
    if (deeplink) {
      bridge.logAnalyticsEvent({
        name: 'CLICK_NEON_SIGN_BOARD',
        analytics: logging.analytics,
        ably_only_log: logging.ably_only_log,
      });
      openDeeplink(deeplink);
    }
  }, [openDeeplink, deeplink, logging]);

  return (
    <Flex onPress={handlePress} disabled={!deeplink}>
      <ImageBackground
        source={{ uri: background_image }}
        style={{
          backgroundColor: ColorValues.gray70,
        }}
        resizeMode="cover"
      >
        <Flex.Row
          padding={{ vertical: 12, horizontal: 16 }}
          alignItems="center"
          gap={12}
        >
          <Flex flex={1}>
            {/* Text 사용: textShadow로 빛번짐(네온) 효과 구현 - Typography는 textShadow 미지원 */}
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              style={{
                fontSize: 14,
                fontWeight: '600',
                color: ColorValues.white,
                textShadowColor: 'rgba(255, 255, 255, 0.8)',
                textShadowOffset: { width: 0, height: 0 },
                textShadowRadius: 10,
              }}
            >
              {title}
            </Text>
          </Flex>
          <Typography type="body4" color="content_disabled">
            {id}
          </Typography>
        </Flex.Row>
      </ImageBackground>
    </Flex>
  );
};

export const NeonSignBoard = ({ entity }: NeonSignBoardProps) => {
  const displayLoggedRef = useRef(false);

  useEffect(() => {
    if (displayLoggedRef.current || isNil(entity) || entity.length === 0) {
      return;
    }
    displayLoggedRef.current = true;
    entity.forEach((data) => {
      bridge.logAnalyticsEvent({
        name: 'DISPLAY_NEON_SIGN_BOARD',
        analytics: data.logging.analytics,
        ably_only_log: data.logging.ably_only_log,
      });
    });
  }, [entity]);

  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  return (
    <Flex>
      {entity.map((data) => (
        <NeonSignBoardItem
          key={data.item.id}
          item={data.item}
          logging={data.logging}
        />
      ))}
    </Flex>
  );
};
